import { DropdownItem, Textbox } from "@mcleod/components";

enum ZoomLevel { // Zoom levels are correlated with hour blocks
    TWO_HUNDRED_PERCENT = "0.5",
    HUNDRED_PERCENT = "1",
    EIGHTY_PERCENT = "2",
    SIXTY_PERCENT = "4"
}

export class TimelineZoomValidator {
    private zoomTb: Textbox;
    private zoomItems: DropdownItem[] = [];

    constructor(zoomTb: Textbox) {
        this.zoomTb = zoomTb;
        this.zoomItems = zoomTb.items as DropdownItem[];
    }

    setValues(daysDisplayed: number, defaultZoom: boolean) {
        if (daysDisplayed <= 3) {
            this.zoomTb.items = this.zoomItems;
        } else {
            this.zoomTb.items = this.zoomItems.filter(item => parseFloat(item.value) >= 1);
        }
        if (defaultZoom)
            this.defaultZoomValue(daysDisplayed);
    }

    defaultZoomValue(daysDisplayed: number) {
        /* The term "zoom" is used to refer to the width of each column in the timeline.
           The percentages correlate to the hours 100% -> 1 hr block intervals. */
        if (daysDisplayed <= 1) {
            this.zoomTb.setSelectedItemFromValue(ZoomLevel.TWO_HUNDRED_PERCENT);
        } else if (daysDisplayed == 2) {
            this.zoomTb.setSelectedItemFromValue(ZoomLevel.HUNDRED_PERCENT);
        } else if (daysDisplayed > 2 && daysDisplayed < 5) {
            this.zoomTb.setSelectedItemFromValue(ZoomLevel.EIGHTY_PERCENT);
        } else {
            this.zoomTb.setSelectedItemFromValue(ZoomLevel.SIXTY_PERCENT);
        }
    }

}
